import {
  CLEAR_VIEWS,
  PREVIOUS_VIEW,
  SET_ACTIVE_FILTER_ID,
  SET_CURRENT_TEMPLATE_ID,
  SET_EDITING_TASK_TEMPLATE_ID,
  SET_TEMPLATE_REORDERING_TYPE,
  SET_VIEW,
} from 'constants/actions';
import { defaultActiveFilter } from 'components/projects/taskList/constants';

const initialState = {
  activeFilterId: defaultActiveFilter,
  currentView: null,
  currentTemplateId: null,
  views: [],
  editingTaskId: null,
  reorderingType: null,
};

export default function templates(
  state = initialState,
  { filterId, type, view, currentTemplateId, reorderingType, taskTemplateId },
) {
  switch (type) {
    case SET_ACTIVE_FILTER_ID:
      return {
        ...state,
        activeFilterId: filterId,
      };
    case SET_VIEW:
      return {
        ...state,
        views: [...state.views, view],
        currentView: view,
      };
    case PREVIOUS_VIEW:
      state.views.length > 1 && state.views.pop();
      return {
        ...state,
        currentView: state.views[state.views.length - 1],
        views: [...state.views],
      };
    case CLEAR_VIEWS:
      return {
        ...state,
        currentView: null,
        views: [],
      };
    case SET_CURRENT_TEMPLATE_ID:
      return {
        ...state,
        currentTemplateId,
      };
    case SET_EDITING_TASK_TEMPLATE_ID:
      return {
        ...state,
        editingTaskId: taskTemplateId,
      };
    case SET_TEMPLATE_REORDERING_TYPE:
      return {
        ...state,
        reorderingType,
      };
    default:
      return state;
  }
}
